export interface LinkedLayer {
    id?: number;
    field: number;
    variant: number;
    layerUuid: string;
    initialValue: string;
    name: string;
    posX: number;
    posY: number;
    width: number;
    height: number;
    fontFamily: string;
    fontWeight: number;
    fontStyle: string;
    fontSize: number;
    lineHeight: number;
    fill: string;
}
